import { dataLayerPush as baseDataLayerPush, TDataLayerPushArgument } from '@r1-frontend/analytics/dataLayerPush';

import { ACTIONS, EVENTS } from '@r1-frontend/shared/constants/analytics';

import { fullBuyEquipAnalyticsBase } from '~/src/analytics';

const dataLayerPush = (
    equipmentTitle: string,
    category: string,
    leasing: number,
    gAcategory: TDataLayerPushArgument<unknown>['category'],
    cost?: number,
): void => {
    baseDataLayerPush({
        event: EVENTS.UAevent,
        category: gAcategory,
        action: ACTIONS.clickedToOrder,
        label: fullBuyEquipAnalyticsBase.buildDataLayerLabel({
            equipmentTitle, category, leasing, cost,
        }),
    });
};

export default dataLayerPush;
